import { useState, useEffect } from 'react';

const useScript = (url) => {
  const [status, setStatus] = useState(url ? 'loading' : 'idle');

  useEffect(() => {
    if (!url) {
      setStatus('idle');
      return;
    }

    let script = document.querySelector(`script[src="${url}"]`);

    if (!script) {
      script = document.createElement('script');
      script.src = url;
      script.async = true;
      document.body.appendChild(script);

      const setAttribute = (element, attribute, value) => {
        if (element) {
            element.setAttribute(attribute, value);
        }
      };
      
      setAttribute(script, 'data-status', 'loading');

      const handleLoad = () => setAttribute(script, 'data-status', 'ready');
      const handleError = () => setAttribute(script, 'data-status', 'error');

      script.addEventListener('load', handleLoad);
      script.addEventListener('error', handleError);
      
    } 
    
    const setState = () => {
        const scriptStatus = script.getAttribute('data-status');
        if (scriptStatus) {
            setStatus(scriptStatus);
        }
    };
    
    // Poll for the script status as it's loaded asynchronously
    const interval = setInterval(setState, 100);
    
    // Initial check
    setState();

    return () => {
      clearInterval(interval);
    };

  }, [url]);

  return status;
};

export default useScript;